enum SignInAttemptError {
    INTERNAL = 'internal',
    IDENTITY_MISSING = 'identity_missing',
    IDENTITY_SHUTDOWN = 'identity_shutdown',
    AUTH_METHOD_NO_SUPPORT = 'auth_method_no_support',
    CREDENTIALS_INVALID = 'credentials_invalid',
}

export default SignInAttemptError;
